<template>
  <ul class="container">
    <li class="header">
      <div class="image-box">
        <van-swipe :autoplay="3000" class="swipe-box">
          <van-swipe-item v-for="(image, index) in swipeArray" :key="index">
            <van-image class="swipe-itme" lazy-load :src="image" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="tips-box f-s-b">
        <div class="left ellipsis f-s-b">
          <!-- <i class="iconfont iconxiaoxi icon-size"></i> -->
          <i class="iconhebei icongonggao icon-size"></i>
          <span>公告:</span>
          <!-- <span>{{tips}}</span> -->
          <van-notice-bar class="notice-box" :text="tips || '暂无公告'" :scrollable="!(tips === '')" />
        </div>
        <div class="right" v-if="tipsDom" v-touch:tap.prevent="lookDetail">详情></div>
      </div>
    </li>
    <ul class="body">
      <li class="render-box">
        <div class="title">预约互动</div>
        <ul class="render-contaier">
          <li
            v-touch:tap="pageRouter(item)"
            class="render-item"
            v-for="(item, index) in serveList"
            :key="index"
          >
            <van-image class="item-iamge" lazy-load fit="contain" :src="item.image" />
            <div class="item-name">{{ item.name }}</div>
          </li>
        </ul>
      </li>
      <li class="render-box">
        <div class="title">云游海博</div>
        <ul class="render-contaier">
          <li
            v-touch:tap="pageRouter(item)"
            class="render-item"
            v-for="(item, index) in serveList2"
            :key="index"
          >
            <van-image class="item-iamge" lazy-load fit="contain" :src="item.image" />
            <div class="item-name">{{ item.name }}</div>
          </li>
        </ul>
      </li>

      <li class="fast-entrance">
        <div class="bg-box">
          <div class="f-s-b info-box">
            <!-- <div class="title">快速预约门票</div> -->
            <div class="f-s-b btn" v-touch:tap="goToTicket">预约门票</div>
          </div>
          <van-image class="inner-bg-box" lazy-load :src="fastEntranceObj.bgImage" />
        </div>
        <!-- <van-image 
                    class="goods-image-bg"
                    lazy-load
                    :src="fastEntranceObj.goodsBg"
                />
                <van-image 
                    class="goods-image"
                    lazy-load
                    :src="fastEntranceObj.goods"
        />-->
      </li>

      <li class="render-box notice-box" v-if="exhibitionList.length || activityList.length">
        <div class="title" v-if="exhibitionList.length > 0">展览预告</div>
        <div
          class="notice-container f-s-b"
          v-for="(item, index) in exhibitionList"
          :key="index"
          v-touch:tap="goToExhibitionDetail(item)"
        >
          <div class="notice-iamge-box">
            <van-image class="notice-iamge" fit="cover" :src="tokenImage(item.image)" />
            <div v-if="item.state === 0" class="tips-label">预告</div>
            <div v-else-if="item.state === 1" class="tips-label blue-label">报名中</div>
            <div v-else-if="item.state === 2" class="tips-label green-label">报名结束</div>
            <div v-else-if="item.state === 3" class="tips-label green-label">进行中</div>
            <div v-else class="tips-label green-label">已结束</div>
          </div>
          <ul class="notice-info f-s-b">
            <li class="info-item ellipsis name">
              <span>{{ item.name }}</span>
            </li>
            <li class="info-item ellipsis time">
              <span class="left-label f-s-b">
                <i v-for="(item, index) in ['展', '出', '时', '间']" :key="index">{{ item }}</i>
              </span>:
              <span>{{ item.time }}</span>
            </li>
            <li class="info-item ellipsis address">
              <span class="left-label f-s-b">
                <i v-for="(item, index) in ['展', '出', '地', '点']" :key="index">{{ item }}</i>
              </span>:
              <span>{{ item.address }}</span>
            </li>
            <li class="info-item ellipsis price">
              <span class="left-label f-s-b">
                <i v-for="(item, index) in ['费', '用']" :key="index">
                  {{
                  item
                  }}
                </i>
              </span>:
              <!-- <span class="money-color">{{item.price > 0 ? item.price : '免费'}}</span> -->
              <span class="money-color">
                {{
                item.price > 0 ? "收费" : "免费"
                }}
              </span>
            </li>
            <li class="info-item ellipsis desc">
              <span>{{ item.desc || "暂无详情" }}</span>
            </li>
          </ul>
        </div>

        <div class="title activity-title" v-if="activityList.length > 0">活动预告</div>
        <div
          class="notice-container f-s-b"
          v-for="(item, index) in activityList"
          :key="index + item.date"
          v-touch:tap="goToActivityDetail(item)"
        >
          <div class="notice-iamge-box">
            <van-image class="notice-iamge" fit="cover" :src="tokenImage(item.image)" />
            <div v-if="item.state === 0" class="tips-label">预告</div>
            <div v-else-if="item.state === 1" class="tips-label blue-label">报名中</div>
            <div v-else-if="item.state === 2" class="tips-label green-label">报名结束</div>
            <div v-else-if="item.state === 3" class="tips-label green-label">进行中</div>
            <div v-else class="tips-label green-label">已结束</div>
          </div>
          <ul class="notice-info f-s-b">
            <li class="info-item ellipsis name">
              <span>{{ item.title }}</span>
            </li>
            <li class="info-item ellipsis time">
              <span class="left-label f-s-b">
                <i v-for="(item, index) in ['展', '出', '时', '间']" :key="index">{{ item }}</i>
              </span>:
              <span>{{ item.date }}</span>
            </li>
            <li class="info-item ellipsis address">
              <span class="left-label f-s-b">
                <i v-for="(item, index) in ['报', '名', '条', '件']" :key="index">{{ item }}</i>
              </span>:
              <span>{{ item.condition }}</span>
            </li>
            <li class="info-item ellipsis price">
              <span class="left-label f-s-b">
                <i v-for="(item, index) in ['费', '用']" :key="index">
                  {{
                  item
                  }}
                </i>
              </span>:
              <!-- <span class="money-color">{{item.price > 0 ? item.price : '免费'}}</span> -->
              <span class="money-color">
                {{
                item.rawData.isCharge == 1 ? "收费" : "免费"
                }}
              </span>
            </li>
            <li class="info-item ellipsis desc">
              <span>{{ item.rawData.intro || "暂无详情" }}</span>
            </li>
          </ul>
        </div>
      </li>

      <li class="foot-bg-box">
        <van-image class="foot-bg" :src="fastEntranceObj.titleImage1" />
      </li>
    </ul>

    <div hidden style="width: 0; height: 0">{{ getIsReadyOk }}</div>

    <van-popup
      v-model="show"
      round
      closeable
      class="tips-popup-box"
      position="bottom"
      :style="{ minHeight: '50%', height: '90%' }"
    >
      <!-- <div class="title g-b-500">公告</div> -->
      <!-- <div>{{tips}}</div> -->
      <div v-if="tipsDom" class="inner-content-box">
        <div class="title g-b-500">{{ tips }}</div>
        <div v-html="tipsDom"></div>
      </div>
      <div v-else>暂无详情</div>
    </van-popup>
  </ul>
</template>

<script>
import { Swipe, SwipeItem, Popup, NoticeBar } from "vant";
import {
  getAllTicketUrl,
  getAllExhibitionUrl,
  getActivityListUrl,
} from "@ticketUrl";
import { getAllNewsUrl } from "@culturalRelicsUrl";
import util from "@util";
import { tokenImage } from "@js/url.js";
import http from "@js/http-ww.js";
export default {
  data() {
    return {
      swipeArray: [require("@image/home/34.png")],
      fastEntranceObj: {
        // bgImage: require('@image/home/goods-bg.png'),
        bgImage: require("@image/home/new-icon/15.png"),
        goodsBg: require("@image/home/goods-small-bg.png"),
        goods: require("@image/home/goods.png"),
        titleImage1: require("@image/home/new-icon/18.png"),
      },
      serveList: [
        {
          // image: require('@image/home/menpiao-4.png'),
          image: require("@image/home/new-icon/1.png"),
          name: "门票预约",
          // routerName: 'ticketing',
          // routerName: 'calendar',
          // type: 'ticket'
          jumpUrl: "http://ticket.hnswb.net/index/museum/index.html?id=1",
          // "https://git.gblw.net/index/museum/index.html?id=1&name=%E6%B5%B7%E5%8D%97%E7%9C%81%E5%8D%9A%E7%89%A9%E9%A6%86",
        },
        // {
        //     // image: require('@image/home/menpiao-5.png'),
        //     image: require('@image/home/new-icon/2.png'),
        //     name: '讲解预约',
        //     routerName: 'explainPage',
        // },
        {
          // image: require('@image/home/3.png'),
          image: require("@image/home/new-icon/3.png"),
          name: "志愿者服务",
          // routerName: 'volunteerPage'
          // TODO:
          jumpUrl: "",
        },
        {
          // image: require('@image/home/huodong-2.png'),
          image: require("@image/home/new-icon/4.png"),
          name: "活动预约",
          // routerName: 'activityPage',
          jumpUrl:
            "http://ticket.hnswb.net/index/activity/list.html?id=1&name=%E6%B5%B7%E5%8D%97%E7%9C%81%E5%8D%9A%E7%89%A9%E9%A6%86",
        },
        {
          // image: require('@image/home/Fill1.png'),
          image: require("@image/home/new-icon/5.png"),
          name: "海博堂",
          // routerName: 'haibotang',
          jumpUrl: "http://shop.hnswb.net/",
        },
        {
          // image: require('@image/home/tousu2.png'),
          image: require("@image/home/new-icon/6.png"),
          name: "投诉建议",
          routerName: "complaints",
        },
        {
          // image: require('@image/home/4.png'),
          image: require("@image/home/new-icon/7.png"),
          name: "一键求助",
          callPhone: "65238880",
        },
        {
          // image: require('@image/home/location.png'),
          image: require("@image/home/new-icon/9.png"),
          name: "位置服务",
          routerName: "drawingMapBoot",
        },
      ],
      serveList2: [
        {
          image: require("@image/home/new-icon/8.png"),
          name: "海博文物",
          routerName: "introductoryArticle",
        },
        {
          image: require("@image/home/new-icon/10.png"),
          name: "海博景观",
          routerName: "scenery",
        },
        {
          image: require("@image/home/new-icon/11.png"),
          name: "虚拟海博",
          routerName: "VirtualHall",
        },
        {
          image: require("@image/home/new-icon/12.png"),
          name: "海博视界",
          routerName: "videoList",
        },
        {
          image: require("@image/home/new-icon/13.png"),
          name: "海博头条",
          routerName: "headlines",
        },
        {
          image: require("@image/home/new-icon/14.png"),
          name: "直播讲解",
          routerName: "videoLiveList",
        },
      ],
      exhibitionList: [
        // {
        //     name: '布衣展',
        //     date: '2019.11.11-2019.12',
        //     address: '1号展馆',
        //     price: 0,
        //     desc: '展览主要展示布艺方面',
        // },
        // {
        //     name: '布衣展',
        //     date: '2019.11.11-2019.12',
        //     address: '1号展馆',
        //     price: 0,
        //     desc: '展览主要展示布艺方面',
        // },
      ],

      activityList: [
        // {
        //     image: require('@image/home/wanglili.png'),
        //     title: '2019亲子活动游',
        //     date: '11月30日星期日  09:00-11:00',
        //     name: '刘某',
        //     condition: '5-7岁',
        //     quota: 0,
        //     rawData: {
        //         intro: '',
        //         isCharge: '',
        //     }
        // },
        // {
        //     image: require('@image/home/342.png'),
        //     title: '小小科学家',
        //     date: '11月30日星期日  09:00-11:00',
        //     name: '刘某',
        //     condition: '5-7岁',
        //     quota: 222,
        //     rawData: {
        //         intro: '',
        //         isCharge: '',
        //     }
        // },
        // {
        //     image: require('@image/home/243242.png'),
        //     title: '2019亲子活动游',
        //     date: '11月30日星期日  09:00-11:00',
        //     name: '刘某',
        //     condition: '5-7岁',
        //     quota: 2,
        //     rawData: {
        //         intro: '',
        //         isCharge: '',
        //     }
        // }
      ],

      //  固定门票对象
      ticketObj: {},
      show: false,
      tips: "",
      tipsDom: "",

      requestParams: {
        nodeId: 170,
        page: -1,
        size: 1,
      },
    };
  },
  methods: {
    init() {
      this.getAllTicketList();
      this.getAllExhibitionList();
      this.getActivityListData();
      this.getNews();
    },
    getNews() {
      this.requestParams.page++;
      http
        .get(getAllNewsUrl, {
          params: {
            ...this.requestParams,
          },
        })
        .then((res) => {
          var {
            data: {
              page: { content = [] },
            },
          } = res.data;
          if (content.length > 0) {
            var data = content[0];
            this.tips = data.title;
            this.tipsDom = data.text;
          }
        });
    },
    tokenImage,
    pageRouter(item) {
      return () => {
        if (item.routerName) {
          // this.$router.push({ name: item.routerName })
          if (item.type) {
            switch (item.type) {
              //  固定门票跳转
              case "ticket":
                this.goToTicket();
                break;
              default:
                break;
            }
          } else {
            this.$router.push({ name: item.routerName });
          }
        } else if (item.callPhone) {
          window.location.href = `tel:${item.callPhone}`;
        } else if (item.jumpUrl) {
          window.location.href = item.jumpUrl;
        } else {
          this.$toast("暂未开放 敬请期待");
        }
      };
    },
    goToTicket() {
      // 2020年09月25日14:58:47 修改
      window.location.href = this.serveList[0].jumpUrl;
      return;

      var {
        id: ticketId,
        isCharge = 0,
        ticketPrice = 0,
        name,
      } = this.ticketObj;
      //  后台字典 isCharge === 0 免费 else 使用票价 ticketPrice
      if (isCharge === 0) {
        ticketPrice = 0;
      }
      this.$store.commit("setParmas", {
        charge: isCharge, // 是否免费
        ticketPrice, //  门票价格
        name, // 门票名称
      });
      this.$router.push({
        name: "calendar",
        query: { ticketId, type: "ticket" },
      });
    },
    //  博物馆固定门票
    getAllTicketList() {
      this.$http.get(getAllTicketUrl).then((res) => {
        if (res.data.length > 0) {
          this.ticketObj = res.data[0];
        }
      });
    },
    goToExhibitionDetail(item) {
      return () => {
        const {
          rawData: { exhibitionId, id: ticketId },
        } = item;
        this.$router.push({
          name: "exhibition",
          query: { ticketId, exhibitionId },
        });
      };
    },

    //  临展数据
    getAllExhibitionList() {
      // 0：窗口 1：官网、2：微信 3：自助机
      this.$http
        .get(getAllExhibitionUrl, { params: { type: 2 } })
        .then((res) => {
          const { data: array = [] } = res;
          this.exhibitionList = [];
          array.map((item) => {
            this.exhibitionList.push({
              name: item.name,
              image: item.image,
              time: `${util.formatTime(
                new Date(),
                "MM.dd hh:mm"
              )} - ${util.formatTime(new Date(), "MM.dd hh:mm")}`,
              address: item.address,
              price: item.isCharge === 0 ? 0 : item.price || 0,
              desc: "暂无详情",
              //  0：预告  1：报名中 2：报名结束  3：进行中 4：已结束
              state: item.status,
              rawData: item,
            });
          });
        });
    },

    //  获取活动列表
    getActivityListData() {
      this.$http
        .get(getActivityListUrl, { params: { days: -100 } })
        .then((res) => {
          const { data: tempArray } = res;
          this.activityList = [];
          tempArray.map((item) => {
            this.activityList.push({
              image: item.image,
              title: item.name,
              state: item.status,
              // date: util.formatTime(new Date(item.startTime),'时分秒') + " - " + util.formatTime(new Date(item.endTime),'时分秒'),
              date: `${util.formatTime(
                new Date(item.startTime),
                "MM.dd hh:mm"
              )} - ${util.formatTime(new Date(item.endTime), "MM.dd hh:mm")}`,
              name: item.speaker,
              condition:
                item.minAge > 0 && item.maxAge > 0
                  ? `${item.minAge} - ${item.maxAge}岁`
                  : "无条件限制",
              quota: item.surplusQuota > 0 ? item.surplusQuota : 0,
              rawData: item,
            });
          });
        });
    },

    //  跳转活动详情
    goToActivityDetail(item) {
      return () => {
        const { id: activityId } = item.rawData;
        this.$router.push({ name: "activityDetail", query: { activityId } });
      };
    },

    lookDetail() {
      this.onChangShow();
    },
    onChangShow() {
      this.show = !this.show;
    },
  },
  computed: {
    getIsReadyOk() {
      var flag = this.$store.state.isReadyOk || false;
      if (flag) {
        this.init();
      }
      return flag;
    },
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Popup.name]: Popup,
    [NoticeBar.name]: NoticeBar,
  },
};
</script>

<style lang="less" scoped>
@import "./style/home-public-style.less";

.container {
  position: relative;
  background-color: #f3f4fe !important;
}
.tips-popup-box {
  // min-height: 40%;
  padding: 40px 20px 10px;
  box-sizing: border-box;
  overflow: hidden;
  .title {
    text-align: center;
    margin-bottom: 10px;
  }
  .inner-content-box {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  img {
    width: 100%;
    min-height: 200px;
  }
}
.header {
  .swipe-box {
    width: 100%;
    height: 100%;
    .swipe-itme {
      width: 100%;
      height: 100%;
    }
  }
  .image-box {
    height: 185px;
  }
  .tips-box {
    margin: 0 7px;
    position: relative;
    top: -23px;
    margin-bottom: -23px;
    background: rgba(11, 109, 176, 1);
    border: 2px solid rgba(78, 183, 255, 1);
    box-shadow: 0px 2px 5px 0px rgba(11, 109, 176, 0.52);
    border-radius: 23px;
    font-size: 14px;
    padding: 0 18px;
    color: #ffffff;
    height: 46px;
    .notice-box {
      background-color: transparent;
      color: #ffffff;
      padding: 0;
      flex: 1;
    }
    // background:linear-gradient(270deg,rgba(32,107,148,1) 0%,rgba(14,57,91,1) 100%);
    .left {
      width: ~"calc(100% - 40px)";
    }
    .right {
      width: 40px;
      text-align: right;
    }
    .icon-size {
      margin-right: 5px;
      &::before {
        font-size: 16px;
      }
    }
  }
}
.body {
  padding: 7px;
  position: relative;
  box-sizing: border-box;
  background: rgba(243, 244, 254, 1);
  .red-box {
    border: 1px solid red;
  }
  .fast-entrance {
    // .red-box();
    // margin-bottom: 12px;
    // margin-top: 5px;
    margin: 5px 7px 12px;
    z-index: 2;
    // padding: 0 7px;
    // overflow: hidden;
    position: relative;
    text-align: right;
    height: auto;
    border-radius: 10px;
    top: -60px;
    position: relative;
    margin-bottom: -65px;
    // box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
    .bg-box {
      // box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
      // border-radius: 10px;
      // background-color: #eff0f9;
      // background-color: #f5f5f5;
      // height: 127px;
      position: relative;
      height: auto;
      // overflow: hidden;
      // position: absolute;
      // bottom: 0;
      // left: 0;
      // right: 0;
      .inner-bg-box {
        width: 100%;
        vertical-align: top;
      }
      .info-box {
        text-align: center;
        // width: 120px;
        flex-direction: column;
        z-index: 2;
        position: absolute;
        top: 100px;
        // bottom: 0px;
        left: 47px;
        .title {
          height: 25px;
          font-size: 18px;
          font-weight: 500;
          color: rgba(83, 89, 106, 1);
          line-height: 24px;
          margin-bottom: 14px;
        }
        .btn {
          color: #ffffff;
          width: 67px;
          height: 26px;
          background: rgba(72, 153, 255, 1);
          border-radius: 13px;
          justify-content: center;

          // 2020-04-09 15:47:10修改
          width: 95px;
          height: 30px;
          background: rgba(230, 108, 62, 1);
          box-shadow: 0px 2px 4px 0px rgba(206, 215, 205, 0.35);
          border-radius: 15px;
          font-size: 14px;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    .goods-image {
      vertical-align: top;
      width: 95px;
      top: 0;
      z-index: 2;
      margin-right: 11px;
    }
    .goods-image-bg {
      position: absolute;
      width: 117px;
      height: 117px;
      bottom: 0;
      right: 0;
      vertical-align: top;
    }
  }
  .render-box {
    box-shadow: 3px 1px 6px 0px rgba(224, 224, 224, 0.5);
    border-radius: 10px;
    padding-top: 12px;
    background-color: #ffffff;
    // margin-bottom: 5px;
    margin-bottom: 12px;
    position: relative;
    overflow: hidden;
    .title {
      margin-bottom: 20px;
      font-size: 16px;
      font-weight: 500;
      color: rgba(96, 101, 117, 1);
      padding-left: 15px;
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 25%;
        height: 5px;
        background: rgba(86, 135, 207, 1);
      }
      &::before {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 75%;
        height: 5px;
        background: rgba(200, 229, 237, 1);
      }
    }
    .render-contaier {
      .render-item {
        position: relative;
        z-index: 5;
        display: inline-block;
        vertical-align: top;
        width: 25%;
        text-align: center;
        margin-bottom: 20px;
        .item-iamge {
          width: 42px;
          height: 42px;
        }
        .item-name {
          font-size: 12px;
          font-weight: 500;
          color: rgba(122, 126, 132, 1);
        }
      }
    }
  }
  .notice-box {
    overflow: visible;
    position: relative;
    margin: 0;
    z-index: 1;
    top: -70px;
    padding-top: 20px;
    margin-bottom: -65px;
    background-color: #134266;
    .title {
      padding-left: 60px;
      position: relative;
      top: 60px;
      color: #ffffff;
      margin-bottom: 15px;
      // &::after,
      &::before {
        content: none;
      }

      &::after {
        content: "";
        vertical-align: top;
        position: absolute;
        left: 20px;
        top: -5px;
        color: #fff;
        width: 43px;
        height: 40px;
        z-index: 3;
        background-color: transparent;
        background-image: url("~@image/home/new-icon/16.png");
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
    .activity-title {
      &::after {
        top: 0;
        left: 15px;
        width: 63px;
        height: 49px;
        background-image: url("~@image/home/new-icon/17.png");
      }
    }
    .notice-container {
      transform: translateY(50px);
      position: relative;
      z-index: 2;
      border-radius: 10px;
      margin: 0 10px 16px;
      padding: 20px 7px 16px;
      // background:rgba(249,243,248,1);
      background-color: #ffffff;

      .notice-iamge-box {
        border-radius: 10px;
        width: 155px;
        height: 120px;
        // overflow: hidden;
        position: relative;
        .notice-iamge {
          border-radius: 10px;
          width: 100%;
          height: 100%;
          vertical-align: top;
          overflow: hidden;
        }
        .tips-label {
          position: absolute;
          top: -0.9px;
          left: -0.4px;
          width: 80px;
          border-top-left-radius: 10px;
          line-height: 28px;
          // padding-left: 23px;
          text-align: center;
          box-sizing: border-box;
          height: 30px;
          background-image: url("../../lib/image/home/yellow.png");
          background-size: 85px 30px;
          background-repeat: no-repeat;
          background-position: center;
          color: #ffffff;
          font-size: 14px;
          font-weight: 500;
          text-shadow: 0px 1px 2px rgba(162, 77, 0, 0.5);
          z-index: 5;
        }

        .blue-label {
          background-image: url("../../lib/image/home/blue.png");
        }
        .green-label {
          background-image: url("../../lib/image/home/green.png");
        }
        .gray-label {
          background-image: url("../../lib/image/home/gray.png");
        }
      }
      .notice-info {
        height: 120px;
        width: ~"calc(100% - 155px)";
        flex-direction: column;
        align-items: flex-start;
        padding-left: 12px;
        font-size: 12px;
        font-weight: 400;
        color: rgba(152, 156, 165, 1);
        .info-item {
          width: 100%;
          .left-label {
            vertical-align: top;
            display: inline-flex;
            width: 48px;
          }
          .money-color {
            color: #ff5a00;
            font-weight: 500;
          }
        }
        .name {
          font-size: 16px;
          font-weight: 500;
          color: rgba(53, 58, 62, 1);
        }
      }
    }
  }
  .foot-bg-box {
    position: absolute;
    z-index: 0;
    bottom: -100px;
    left: 0;
    right: 0;
    overflow: hidden;
    .foot-bg {
      top: 110px;
      position: relative;
      width: 100%;
      vertical-align: top;
      z-index: 0;
    }
  }
}
</style>